import MenuService from "../../core/components/menu/MenuService";
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import {store} from './../../plugins/vuex/index'
import Redoc from "@/modules/docs/Redoc.vue";
const routes = [
  {
    path: 'docs',
    name: 'docs',
    component: Redoc,
    meta: {
      requiresAuth: true
    }
  },
];


MenuService.addMenuItem(new MenuItem('/docs', i18n.t('Documentation'), 20, 'book', [], '', [], function () {
  return store.state.global.currentUser && store.state.global.currentUser.is_api_user;
}));

export {routes}
